import { Utility as util}  from '../services/utility';

export class Payment {
    planId: number
    billingZipCode: string
    ccNumber: string
    ccv2Code: string
    ccExpirationYear: string
    ccExpirationMonth: string
}
export class PaymentMethod {
    contactfirstname: string;
    contactlastname: string;
    contactemail: string;
    contactphone: string;
    cardholderfirstname: string;
    cardholderlastname: string;
    cardnumber: string;
    cardexpirationmonth: string;
    cardexpirationyear: string;
    billingzip: string;
    ccv: string;
    active: boolean;
    ispreffered: boolean; 
}
export class PaymentMethodResult {
    ispreffered: boolean;
    ccv: string;
    cardnumber: string;
    cardid: string;
    cardholderlastname: string;
    cardholderfirstname: string;
    cardexpirationyear: string;
    cardexpirationmonth: string;
    billingzip: string;
    active: boolean;
    cardtype:string;
}
export class Message {
    code: string;
    description: string;
    text: string;
}

export class UserField {
    name: string;
    value: string;
}

export class TransactionResponse {
    responseCode: string;
    authCode: string;
    avsResultCode: string;
    cvvResultCode: string;
    cavvResultCode: string;
    transId: string;
    refTransID: string;
    transHash: string;
    testRequest: string;
    accountNumber: string;
    accountType: string;
    messages: Message[];
    userFields: UserField[];
    transHashSha2: string;
}


export class Messages {
    resultCode: string;
    message: Message[];
}

export class IntakeTransactionResponse {
    transactionResponse: TransactionResponse;
    refId: string;
    messages: Messages;
}
export class IntakePaymentCharge {
    amount: string;
    intakeid: string;
    transactiontype: string;
    lineOfBusiness: string;
    userid: number;
    intakeScheduleDate: Date;
}
export class Month {
    name: string;
    abbreviation: string;
    order: number;
    get orderString() : string {
        return util.padStart("0",this.order,2);
    }
      constructor(monthOrder: number, monthName: string, monthAbbreviation: string) {
          this.name = monthName;
         this.order = monthOrder;
      }
  }

  export class Months {
    static  January   = new Month(1,"January","Jan");
    static  February  = new Month(2,"February","Feb");
    static  March     = new Month(3,"March","Mar");
    static  April     = new Month(4,"April","Apr");
    static  May       = new Month(5,"May","May");
    static  June      = new Month(6,"June","Jun");
    static  July      = new Month(7,"July","Jul");
    static  August    = new Month(8,"August","Aug");
    static  September = new Month(9,"September","Sep");
    static  October   = new Month(10,"October","Oct");
    static  November  = new Month(11,"November","Nov");
    static  December  = new Month(12,"December","Dec");
  
    public static get asArray() 
    {
       return [
         this.January,
         this.February,
         this.March,
         this.April,
         this.May,
         this.June,
         this.July,
         this.August,
         this.September,
         this.October,
         this.November,
         this.December
       ];            
    } 
  
  }